module.exports = __webpack_public_path__ + "img/trouve-pas.072ae0d6.svg";